<template>
  <v-dialog
    :max-width="resourceLimitModalType === 'resoucesRestored' ? 1000 : 880"
    :fullscreen="smAndDown"
    v-model="dialogValue"
    eager
    persistent
  >
    <v-card class="tw-relative" :class="[smAndDown ? '' : 'tw-rounded-3xl']">
      <template v-if="resourceLimitModalType === 'resoucesRestored'">
        <v-img
          src="@/assets/modal-backgrond-wave.svg"
          width="100%"
          class="tw-absolute tw-top-0 tw-left-0 tw-select-none tw-pointer-events-none"
        />
      </template>
      <v-btn
        variant="text"
        class="tw-absolute tw-top-0 tw-right-0 tw-m-2 tw-text-slate-500 hover:tw-text-slate-700"
        icon="mdi-close"
        @click="dialogValue = false"
      />
      <v-row no-gutters class="tw-p-0">
        <v-col
          cols="12"
          md="6"
          class="tw-flex tw-justify-center tw-items-center tw-w-full md:tw-w-[45%]"
          :class="
            resourceLimitModalType === 'resoucesRestored'
              ? 'tw-pl-12 tw-py-6'
              : 'tw-px-12 tw-py-12'
          "
        >
          <ResourceUseLimitInfo
            :class="{
              'tw-min-w-[432px]': resourceLimitModalType === 'resoucesRestored',
            }"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="tw-flex tw-justify-center tw-items-center tw-w-full tw-px-12 md:tw-w-[55%]"
          :class="
            resourceLimitModalType === 'resoucesRestored'
              ? 'tw-py-6'
              : 'tw-py-12 tw-bg-primary-500/5'
          "
        >
          <PricingPlans />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useDisplay } from 'vuetify'
import { useUserMetricsStore } from '@/stores/userMetrics'

const { smAndDown } = useDisplay()
const dialogValue = defineModel({ type: Boolean, required: true })
const userMetricsStore = useUserMetricsStore()
const { resourceLimitModalType } = storeToRefs(userMetricsStore)
</script>

<style lang="scss" scoped></style>
